/** biome-ignore-all lint/style/useNamingConvention: allow snake case */
import {isProOrPartyPassUser} from '~/CreateFabricInvitation/utils/experiments';
import {INIT_APP} from '~/common/fabric/constants';
import {getTimezone} from '~/common/utils';
import {USER_LOGGED_IN} from '~library/organisms/LoginModal/reducer';
import {UPDATE_EVENT_DETAILS} from './constants';

const timezone = getTimezone();

function initGuestsOfHonor() {
  const guests = [];
  for (const guest of window.guestsOfHonor) {
    guests.push({name: guest.name, email: guest.email});
  }
  return {update: false, guests};
}

export const initialState = {
  address: {city: '', state: '', street: '', zip: '', unitNum: '', country: ''},
  phoneNumber: '',
  cohost: {name: '', email: ''},
  guestsOfHonor: {guests: [], update: false},
  guestsUpdated: false,
  host_ids: [],
  end: '',
  host: window.userName || '',
  location: '',
  showMap: true,
  notes: '',
  pending_host_ids: [],
  request: {failed: false, pending: false, success: false},
  start: '',
  stop: '',
  known_timezone_abbr: timezone?.timezoneAbbr || '',
  known_timezone_name: timezone?.timezoneId || '',
  title: '',
  type: '',
  isPremium: false,
  hideUpsell: false,
  isUpsellMode: false,
  inEditMode: false,
  preventUpdateModal: false,
  // The default behavior is to have rsvps enabled (rsvp_off = false)
  // Some templates might have the rsvp optional flag enabled, so in that
  // case, we set rsvp_off = true by default, unless the user chooses to
  // keep rsvps by toggling rsvps on. The rsvp_off value is then saved in the event.
  rsvp_off:
    window?.evite_event?.rsvp_off !== undefined
      ? window.evite_event.rsvp_off
      : !!window?.fabricTemplate?.rsvp_optional,
  hasUpgraded: false,
  confirmationType: '',
  // Data analytics tracking fields
  tracking_gallery_category: '',
  pristine: true,
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_EVENT_DETAILS:
      return {
        ...state,
        ...action.payload,
        pristine: false,
      };
    case USER_LOGGED_IN:
      return {
        ...state,
        host: state.host || action.userName,
        isPremium: state.isPremium || isProOrPartyPassUser(action.subscriptionPlanName),
      };
    case INIT_APP: {
      const {event, user, template, override_freemium} = action.payload ?? {};
      const {host_ids, pending_host_ids} = event ?? {};

      if (!event) {
        return {
          ...state,
          host: user.userName,
          isPremium:
            override_freemium ||
            template?.premium ||
            isProOrPartyPassUser(window?.subscriptionPlanName),
          hideUpsell: template?.premium || override_freemium,
          type: action.payload.category_event_type || template?.event_type || '',
          tracking_gallery_category: action.payload.category_id,
        };
      }

      return {
        ...state,
        allowGifts: !!event.options.event_option_show_gifting,
        allowGuests: event.options.event_option_allow_guest_number,
        allowInviteMore: event.options.event_option_allow_invite_more,
        allowKids: event.options.event_option_allow_kids,
        address: {
          city: event.city,
          state: event.state,
          street: event.street_address,
          zip: event.zip_code,
          unitNum: event.unit_num,
          country: event.country,
        },
        phoneNumber: event.phone_number || '',
        cohost: {
          name: event.cohost_name1 || '',
          email: event.cohost_email1 || '',
        },
        end: event.end_datetime,
        guestsOfHonor: initGuestsOfHonor(),
        hideUpsell: event.is_fabric_premium || event.is_upgrade,
        host: event.host_name || user.userName,
        host_ids,
        inEditMode: event.status === 'sending',
        isPremium: event.is_fabric_premium || isProOrPartyPassUser(window?.subscriptionPlanName),
        known_timezone_abbr: event.known_timezone_abbr || timezone.timezoneAbbr,
        known_timezone_name: event.known_timezone_name,
        location: event.location_name,
        meetingUrl: event.meeting_url,
        notes: event.message,
        pending_host_ids,
        placeId: event.place_id,
        rsvp_off: event.rsvp_off,
        showMap: event.options.event_option_allow_view_map,
        start: event.start_datetime,
        stop: event.stop_datetime,
        title: event.title,
        tracking_gallery_category: event.tracking_data?.gallery_category,
        type: event.event_type,
      };
    }
    default:
      return state;
  }
};
